import { RouteConfig } from "vue-router";
import RatingsComponent from "@/views/ratings/ratings.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/ratings",
    name: "Ratings",
    component: RatingsComponent,
    meta: {
      roles: [Roles.PracticeUser, Roles.OfficeUser],
      nav: true,
      navTitle: "Shift Rating Center",
      navIcon: "fa-star"
    }
  }
] as RouteConfig[];